function computeReadableDate(date: Date) {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    return date.toLocaleDateString('fr-FR', options);
}

function convertFrenchDateToISO(dateString: string): string {
    const [day, month, year] = dateString.split('/');
    const isoDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    return isoDateString;
}

export { computeReadableDate, convertFrenchDateToISO };
